export const dataASINC = [
  {
    conceptId: 'C0024117',
    conceptName: 'Asthma',
    recall: '97.2%',
    precision: '96.2%',
    fMeasure: '96.7%',
    truePositives: '1945',
    falsePositives: '76',
    falseNegatives: '56',
  },
  {
    conceptId: 'C0024118',
    conceptName: 'Asthma (moderate)',
    recall: '94.7%',
    precision: '96.4%',
    fMeasure: '95.6%',
    truePositives: '54',
    falsePositives: '2',
    falseNegatives: '3',
  },
  {
    conceptId: 'C0024119',
    conceptName: 'Asthma (severe)',
    recall: '89.6%',
    precision: '90.9%',
    fMeasure: '90.2%',
    truePositives: '60',
    falsePositives: '6',
    falseNegatives: '7',
  },
  {
    conceptId: 'C0024129',
    conceptName: 'Chest tightness',
    recall: '87.6%',
    precision: '95.8%',
    fMeasure: '91.5%',
    truePositives: '92',
    falsePositives: '4',
    falseNegatives: '13',
  },
  {
    conceptId: 'C0024139',
    conceptName: 'Chronic obstructive pulmonary disease',
    recall: '96.4%',
    precision: '92.3%',
    fMeasure: '94.3%',
    truePositives: '1264',
    falsePositives: '105',
    falseNegatives: '47',
  },
  {
    conceptId: 'C0024149',
    conceptName: 'Cough',
    recall: '96.2%',
    precision: '96.3%',
    fMeasure: '96.3%',
    truePositives: '1099',
    falsePositives: '42',
    falseNegatives: '43',
  },
  {
    conceptId: 'C0024159',
    conceptName: 'Dyspnea',
    recall: '95.5%',
    precision: '95.5%',
    fMeasure: '95.5%',
    truePositives: '1423',
    falsePositives: '67',
    falseNegatives: '67',
  },
  {
    conceptId: 'C0024169',
    conceptName: 'Forced expiratory volume',
    recall: '99.1%',
    precision: '97.9%',
    fMeasure: '98.5%',
    truePositives: '550',
    falsePositives: '12',
    falseNegatives: '5',
  },
  {
    conceptId: 'C0024179',
    conceptName: 'Gastroesophageal reflux disease',
    recall: '97.3%',
    precision: '92.8%',
    fMeasure: '95.0%',
    truePositives: '1063',
    falsePositives: '83',
    falseNegatives: '30',
  },
  {
    conceptId: 'C0024170',
    conceptName: 'Pulmonary function test',
    recall: '96.1%',
    precision: '87.8%',
    fMeasure: '91.8%',
    truePositives: '809',
    falsePositives: '112',
    falseNegatives: '33',
  },
  {
    conceptId: 'C0024171',
    conceptName: 'Smoking',
    recall: '91.1%',
    precision: '91.1%',
    fMeasure: '91.1%',
    truePositives: '1262',
    falsePositives: '124',
    falseNegatives: '123',
  },
];

export const dataINSIGHT = [
  {
    conceptId: 'C0024129',
    conceptName: 'Allergic rhinitis',
    recall: '93.02%',
    precision: '98.77%',
    fMeasure: '95.81%',
    truePositives: '320',
    falsePositives: '4',
    falseNegatives: '24',
  },
  {
    conceptId: 'C0024130',
    conceptName: 'Anxiety disorder',
    recall: '93.81%',
    precision: '97.25%',
    fMeasure: '95.50%',
    truePositives: '106',
    falsePositives: '3',
    falseNegatives: '7',
  },
  {
    conceptId: 'C0024131',
    conceptName: 'Asthma',
    recall: '96.49%',
    precision: '96.05%',
    fMeasure: '96.27%',
    truePositives: '2800',
    falsePositives: '115',
    falseNegatives: '102',
  },
  {
    conceptId: 'C0024132',
    conceptName: 'Asthma (mild)',
    recall: '87.19%',
    precision: '89.85%',
    fMeasure: '88.50%',
    truePositives: '177',
    falsePositives: '20',
    falseNegatives: '26',
  },
  {
    conceptId: 'C0024133',
    conceptName: 'Asthma (moderate)',
    recall: '84.54%',
    precision: '97.62%',
    fMeasure: '90.61%',
    truePositives: '82',
    falsePositives: '2',
    falseNegatives: '15',
  },
  {
    conceptId: 'C0024134',
    conceptName: 'Asthma (severe)',
    recall: '88.24%',
    precision: '91.46%',
    fMeasure: '89.82%',
    truePositives: '75',
    falsePositives: '7',
    falseNegatives: '10',
  },
  {
    conceptId: 'C0024135',
    conceptName: 'Bronchiectasis',
    recall: '95.35%',
    precision: '95.35%',
    fMeasure: '95.35%',
    truePositives: '41',
    falsePositives: '2',
    falseNegatives: '2',
  },
  {
    conceptId: 'C0024136',
    conceptName: 'Cancer',
    recall: '91.16%',
    precision: '90.66%',
    fMeasure: '90.91%',
    truePositives: '330',
    falsePositives: '34',
    falseNegatives: '32',
  },
  {
    conceptId: 'C0024137',
    conceptName: 'Chronic obstructive pulmonary disease',
    recall: '95.81%',
    precision: '93.34%',
    fMeasure: '94.56%',
    truePositives: '1668',
    falsePositives: '119',
    falseNegatives: '73',
  },
  {
    conceptId: 'C0024138',
    conceptName: 'Chronic sinusitis',
    recall: '92.26%',
    precision: '97.95%',
    fMeasure: '95.02%',
    truePositives: '143',
    falsePositives: '3',
    falseNegatives: '12',
  },
  {
    conceptId: 'C0024139',
    conceptName: 'Cystic fibrosis',
    recall: '96.67%',
    precision: '95.08%',
    fMeasure: '95.87%',
    truePositives: '58',
    falsePositives: '3',
    falseNegatives: '2',
  },
  {
    conceptId: 'C0024140',
    conceptName: 'Depression',
    recall: '96.71%',
    precision: '92.57%',
    fMeasure: '94.59%',
    truePositives: '411',
    falsePositives: '33',
    falseNegatives: '14',
  },
  {
    conceptId: 'C0024141',
    conceptName: 'Diabetes',
    recall: '96.31%',
    precision: '88.59%',
    fMeasure: '92.29%',
    truePositives: '365',
    falsePositives: '47',
    falseNegatives: '14',
  },
  {
    conceptId: 'C0024142',
    conceptName: 'Dyslipidemia',
    recall: '94.28%',
    precision: '99.38%',
    fMeasure: '96.76%',
    truePositives: '478',
    falsePositives: '3',
    falseNegatives: '29',
  },
  {
    conceptId: 'C0024143',
    conceptName: 'Eosinophilic esophagitis',
    recall: '92.86%',
    precision: '86.67%',
    fMeasure: '89.66%',
    truePositives: '13',
    falsePositives: '2',
    falseNegatives: '1',
  },
  {
    conceptId: 'C0024144',
    conceptName: 'Gastroesophageal reflux disease',
    recall: '96.63%',
    precision: '94.17%',
    fMeasure: '95.38%',
    truePositives: '1518',
    falsePositives: '94',
    falseNegatives: '53',
  },
  {
    conceptId: 'C0024145',
    conceptName: 'Hypertension',
    recall: '95.97%',
    precision: '95.72%',
    fMeasure: '95.84%',
    truePositives: '715',
    falsePositives: '32',
    falseNegatives: '30',
  },
  {
    conceptId: 'C0024146',
    conceptName: 'Insomnia',
    recall: '87.25%',
    precision: '93.53%',
    fMeasure: '90.28%',
    truePositives: '130',
    falsePositives: '9',
    falseNegatives: '19',
  },
  {
    conceptId: 'C0024147',
    conceptName: 'Lung cancer',
    recall: '92.68%',
    precision: '95.00%',
    fMeasure: '93.83%',
    truePositives: '38',
    falsePositives: '2',
    falseNegatives: '3',
  },
  {
    conceptId: 'C0024148',
    conceptName: 'Nasal polyp',
    recall: '92.86%',
    precision: '81.25%',
    fMeasure: '86.67%',
    truePositives: '26',
    falsePositives: '6',
    falseNegatives: '2',
  },
  {
    conceptId: 'C0024149',
    conceptName: 'Sleep apnea',
    recall: '96.27%',
    precision: '97.07%',
    fMeasure: '96.67%',
    truePositives: '232',
    falsePositives: '7',
    falseNegatives: '9',
  },
  {
    conceptId: 'C0024150',
    conceptName: 'Smoking',
    recall: '91.25%',
    precision: '91.11%',
    fMeasure: '91.18%',
    truePositives: '1752',
    falsePositives: '171',
    falseNegatives: '168',
  },
];

export const studyASINC = ['ASINC', 'Internal ASINC', 'Internal testing', 'ASINC study'];
export const studyINSIGHT = ['INSIGHTS exploration', 'INSIGHTS study'];
